import React from 'react';
import { connect } from 'react-redux';

import SponsorshipListSummaryItem from '../../common/sponsorships/list/sponsorshipListSummaryItem';
import * as selectors from '../upcomingPublication.selectors';
import { numberFormatter } from '../../common/formatter';

const UpcomingPublicationListSummaryComponent = ({ recordTotal, priceTotal, isLoading}) => {

    if(isLoading) {
        return <span>Loading summary...</span>;
    }

    const summaryData = [
        { name: "Upcoming Publications", value: numberFormatter.format(recordTotal) },
        { name: "Price", value: numberFormatter.formatAsCurrency(priceTotal, 0) }
    ];

    let items = summaryData.map(summaryItem => <SponsorshipListSummaryItem key={summaryItem.name} name={summaryItem.name} value={summaryItem.value} />);

    return (
        <div className="summary-container">
            {items}
        </div>
    );
};

function mapStateToProps(state) {
    const totalsInfo = selectors.getTotalsInfo(state) || {};
    let priceTotal = 0;
    if(totalsInfo && Object.keys(totalsInfo).length > 0) {
        priceTotal = totalsInfo.price;
    }
    return {
        isLoading: selectors.isUpcomingPublicationDataLoading(state),
        ...selectors.getPaginationInfo(state),
        priceTotal
    };
  }
  
const UpcomingPublicationListSummary = connect(mapStateToProps)(UpcomingPublicationListSummaryComponent);
export default UpcomingPublicationListSummary;